import type { SVGProps } from "react";
export const CloseSmall = (props: SVGProps<SVGSVGElement>) => (
	<svg
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
		viewBox="0 0 24 24"
		aria-hidden={true}
		{...props}
	>
		<path
			d="M8.22707 16.8365L7.16357 15.773L10.9366 12L7.16357 8.25201L8.22707 7.18851L12.0001 10.9615L15.7481 7.18851L16.8116 8.25201L13.0386 12L16.8116 15.773L15.7481 16.8365L12.0001 13.0635L8.22707 16.8365Z"
			fill="currentColor"
		/>
	</svg>
);
